const codes = { 404: 404 } as const

export default {
  codes,
}
